import { OktonInput, OktonSelect } from '@okton/platform-ui';
import { Divider, VStack, useColorModeValue } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

type ConfigurarFormProps = {
  data?: { nome?: string } | null;
};

export default function ConfigurarForm({ data }: ConfigurarFormProps) {
  const [nome, setNome] = useState('');
  const [ambiente, setAmbiente] = useState('prod');
  const [sync, setSync] = useState('60');
  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');
  const [url, setUrl] = useState('');

  const dividerColor = useColorModeValue('gray.200', 'gray.600');

  useEffect(() => {
    if (data) setNome(data.nome || '');
  }, [data]);

  return (
    <VStack spacing="4">
      <OktonInput
        name="nome"
        label="Nome Customizado (opcional)"
        value={nome}
        onChange={e => setNome(e.target.value)}
      />

      <OktonSelect
        name="ambiente"
        label="Ambiente"
        value={ambiente}
        onChange={e => setAmbiente(e.target.value)}
        options={[
          { value: 'prod', label: 'Produção' },
          { value: 'homo', label: 'Homologação' },
        ]}
      />

      <OktonInput
        name="sync"
        label="Intervalo de Sincronização (minutos)"
        value={sync}
        onChange={e => setSync(e.target.value)}
      />

      <Divider borderColor={dividerColor} />

      <OktonInput
        name="apiKey"
        label="API Key"
        value={apiKey}
        onChange={e => setApiKey(e.target.value)}
      />

      <OktonInput
        name="apiSecret"
        label="API Secret"
        value={apiSecret}
        onChange={e => setApiSecret(e.target.value)}
      />

      <OktonInput
        name="url"
        label="URL da API"
        value={url}
        onChange={e => setUrl(e.target.value)}
      />
    </VStack>
  );
}
